<template>
  <MainLayout />
</template>

<script>
import MainLayout from "./Layout/MainLayout.vue";
import './App.css';

export default {
  name: "App",
  components: {
    MainLayout,
  },
};
</script>

<style>

</style>
